export const getSportName = (sport: string) => {
  switch (sport) {
    case 'mlb':
      return 'Baseball';
    case 'nfl':
      return 'Football';
    case 'all':
      return 'All Sports';
    default:
      return sport;
  }
}
